// extracted by mini-css-extract-plugin
export default {"cls1":"SuggestedContentSidebar-cls1___0d5a7c45df4c9d099b6","cls2":"SuggestedContentSidebar-cls2___2a40cd4c5b1eef5a118 SuggestedContentSidebar-cls1___0d5a7c45df4c9d099b6"};